export const environment = {
  /**
   * Whether Angular is running in production mode or not
   */
  production: true,
};
